module.exports = __webpack_public_path__ + "img/logo.bb3882f4.png";